// Form helpers for the get-quote step: US phone masking + email validation.

/** The national 10 digits of a US phone (drops a leading country-code "1"). */
export function phoneDigits(input: string): string {
  let d = input.replace(/\D/g, "");
  if (d.length === 11 && d.startsWith("1")) d = d.slice(1);
  return d.slice(0, 10);
}

/**
 * Masks input to the US format `+1 (000) 000-0000` as the user types. Accepts pasted values like
 * `5125551234`, `(512) 555-1234`, or `+15125551234`. Empty input keeps the `+1 ` affordance.
 */
export function formatUsPhone(input: string): string {
  const digits = phoneDigits(input);
  if (digits.length === 0) return "+1 ";
  const a = digits.slice(0, 3), b = digits.slice(3, 6), c = digits.slice(6, 10);
  if (digits.length <= 3) return `+1 (${a}`;
  if (digits.length <= 6) return `+1 (${a}) ${b}`;
  return `+1 (${a}) ${b}-${c}`;
}

/** A complete US phone has exactly 10 national digits. */
export function isPhoneComplete(input: string): boolean {
  return phoneDigits(input).length === 10;
}

/** Lightweight email shape check — local@domain.tld, no spaces. */
export function isValidEmail(email: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
}
